/* eslint-disable */
import {
  Box,
  Grid,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import { getAnteojo, getArreglo } from "../../services/ProduccionService";
import Message from "../../utils/Message";
//
// ###########################################################################
//
const DatosAnteojoArreglo = (props) => {
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [esAnteojo, setEsAnteojo] = useState(false);
  const [anteojo, setAnteojo] = useState({});
  const [esArreglo, setEsArreglo] = useState(false);
  const [arreglo, setArreglo] = useState({});
  const { anteojoArreglo, idGcAnteojoArreglo } = props;

  const tableColumnsTratamiento = [
    {
      field: "ojo",
      headerName: "Ojo",
      align: "center",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ojo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tr_tipo",
      headerName: "Tipo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tr_tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tr_marca",
      headerName: "Marca",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tr_marca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "tiempo_produccion",
      headerName: "Tiempo de Producción",
      type: "number",
      align: "center",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tiempo_produccion;
        _val = _val ? _val + " días" : "";
        return _val;
      },
    },
  ];

  const tableColumnsFornitura = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Servicio",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cant",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableColumnsServicio = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cant",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    getRowId: (row) =>
      row.id_gc_anteojo_tratamiento ??
      row.id_gc_arreglo_servicio ??
      row.id_gc_arreglo_tratamiento ??
      row.id_gc_arreglo_fornitura ??
      row.id_articulo ??
      row.id ??
      `${row.codigo_articulo ?? ''}-${row.descripcion_articulo ?? ''}-${row.cantidad ?? ''}`,
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadDatosAnteojoArreglo = async () => {
      const response =
        anteojoArreglo == "anteojo"
          ? await getAnteojo(idGcAnteojoArreglo)
          : await getArreglo(idGcAnteojoArreglo);

      if (response.ok) {
        if (response.data.data.anteojo) {
          // si es un anteojo

          let _anteojoObject = response.data.data.anteojo;

          _anteojoObject = {
            ..._anteojoObject,
            cristalOI: _anteojoObject.codigo_articulo_cristal_oi
              ? _anteojoObject.codigo_articulo_cristal_oi +
              " - " +
              _anteojoObject.modelo_articulo_cristal_oi
              : "",
            cristalOD: _anteojoObject.codigo_articulo_cristal_od
              ? _anteojoObject.codigo_articulo_cristal_od +
              " - " +
              _anteojoObject.modelo_articulo_cristal_od
              : "",
            armazonAsol:
              _anteojoObject.codigo_articulo +
              " - " +
              _anteojoObject.descripcion_articulo +
              " - " +
              _anteojoObject.descripcion_ar_as_marca +
              " - " +
              _anteojoObject.modelo_articulo,
            clienteDejaSuAnteojoDetalle: _anteojoObject.cliente_deja_su_anteojo
              ? "CLIENTE DEJO SU ANTEOJO"
              : "",
            nombreApellidoCliente:
              _anteojoObject.nombre_cliente + " " + _anteojoObject.apellido_cliente,
            telefonosCliente:
              _anteojoObject.telefono_movil_cliente + " " + _anteojoObject.telefono_cliente,
            fechaNacimientoClienteEdad:
              _anteojoObject.fecha_nac_cliente + " - " + _anteojoObject.edad_cliente + " años",
            tipoDeAnteojo:
              _anteojoObject.tipo_anteojo === "monofocal-cerca"
                ? "Monofocal de cerca"
                : _anteojoObject.tipo_anteojo === "monofocal-lejos"
                  ? "Monofocal de lejos"
                  : _anteojoObject.tipo_anteojo === "monofocal-intermedia"
                    ? "Monofocal intermedia"
                    : _anteojoObject.tipo_anteojo === "bifocal"
                      ? "Bifocal"
                      : _anteojoObject.tipo_anteojo === "multifocal"
                        ? "Multifocal"
                        : _anteojoObject.tipo_anteojo === "ocupacional"
                          ? "Ocupacional"
                          : "",
            anteojoTratamientoRows: response.data.data.anteojo.gc_anteojo_tratamiento_list,
          };
          setEsAnteojo(true);
          setAnteojo(_anteojoObject);
        } else {
          // si es un arreglo

          let _arregloObject = response.data.data.arreglo;

          _arregloObject = {
            ..._arregloObject,
            armazonAsol:
              _arregloObject.codigo_articulo +
              " - " +
              _arregloObject.descripcion_articulo +
              " - " +
              _arregloObject.descripcion_ar_as_marca +
              " - " +
              _arregloObject.modelo_articulo,
            nombreApellidoCliente:
              _arregloObject.nombre_cliente + " " + _arregloObject.apellido_cliente,
            telefonosCliente:
              _arregloObject.telefono_movil_cliente + " " + _arregloObject.telefono_cliente,
            fechaNacimientoClienteEdad:
              _arregloObject.fecha_nac_cliente + " - " + _arregloObject.edad_cliente + " años",
            arregloTratamientoRows: response.data.data.arreglo.gc_arreglo_tratamiento_list,
            arregloServicioRows: response.data.data.arreglo.gc_arreglo_servicio_list,
            arregloFornituraRows: response.data.data.arreglo.gc_arreglo_fornitura_list,
          };
          setEsArreglo(true);
          setArreglo(_arregloObject);
        }
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };
    loadDatosAnteojoArreglo();
  }, []);

  // ################################################################################
  //
  return (
    <>
      {(esAnteojo || esArreglo) && (
        <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
          <Typography variant="h6" gutterBottom>
            Datos de {esAnteojo ? "Anteojo" : "Arreglo"}
          </Typography>
          {esAnteojo && (
            <>
              <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Armazón / Anteojo de Sol
                    </Typography>
                  </Grid>
                </Grid>

                {anteojo.montura_nuevo_cliente === "nuevo" && (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="armazonAsol"
                        label="Código - Descripción - Marca - Modelo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="armazonAsol"
                        value={anteojo.armazonAsol}
                      />
                    </Grid>
                  </>
                )}

                {anteojo.montura_nuevo_cliente === "cliente" && anteojo.cliente_deja_su_anteojo && (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="cliente_deja_su_anteojo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="cliente_deja_su_anteojo"
                        value={anteojo.clienteDejaSuAnteojoDetalle}
                      />
                    </Grid>
                  </>
                )}

                {anteojo.montura_nuevo_cliente === "cliente" &&
                  !anteojo.cliente_deja_su_anteojo && (
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography
                          variant="overline"
                          gutterBottom
                          sx={{ fontWeight: "bold", color: "brown" }}
                        >
                          EL CLIENTE NO DEJO SU ANTEOJO
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TextField
                          id="estado_montura"
                          label="Estado de la montura"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                          name="estado_montura"
                          value={anteojo.estado_montura}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={1} lg={1}>
                        <TextField
                          id="medida_horizontal"
                          label="Medida horizontal"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="medida_horizontal"
                          value={anteojo.medida_horizontal}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={1} lg={1}>
                        <TextField
                          id="medida_vertical"
                          label="Medida vertical"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="medida_vertical"
                          value={anteojo.medida_vertical}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={1} lg={1}>
                        <TextField
                          id="medida_diagonal"
                          label="Medida diagonal"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="medida_diagonal"
                          value={anteojo.medida_diagonal}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={1} lg={1}>
                        <TextField
                          id="medida_puente"
                          label="Medida puente"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="medida_puente"
                          value={anteojo.medida_puente}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={1} lg={1}>
                        <TextField
                          id="medida_mayor"
                          label="Medida mayor"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="medida_mayor"
                          value={anteojo.medida_mayor}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={2} lg={2}>
                        <TextField
                          id="perfil"
                          label="Perfil"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="perfil"
                          value={anteojo.perfil}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={2} lg={2}>
                        <TextField
                          id="caracteristica"
                          label="caracteristica"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="caracteristica"
                          value={anteojo.caracteristica}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={1} lg={1}>
                        <TextField
                          id="base"
                          label="base"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="base"
                          value={anteojo.base}
                        />
                      </Grid>
                    </Grid>
                  )}
              </Box>

              <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Cristales
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <TextField
                      id="tipoAnteojo"
                      label="Tipo de Anteojo"
                      size="small"
                      sx={{ width: "100%", mb: 1 }}
                      inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                      name="tipoDeAnteojo"
                      value={anteojo.tipoDeAnteojo ? anteojo.tipoDeAnteojo : ""}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <TextField
                      id="cristalOD"
                      label="Cristal para ojo derecho"
                      size="small"
                      sx={{ width: "100%", mb: 1 }}
                      inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                      name="cristalOD"
                      value={anteojo.cristalOD ? anteojo.cristalOD : ""}
                      variant="outlined"
                      multiline
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <TextField
                      id="cristalOI"
                      label="Cristal para ojo izquierdo"
                      size="small"
                      sx={{ width: "100%", mb: 1 }}
                      inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                      name="cristalOI"
                      value={anteojo.cristalOI ? anteojo.cristalOI : ""}
                      variant="outlined"
                      multiline
                    />
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item sm={2}></Grid>

                    <Grid item sm={2}></Grid>

                    <Grid item sm={2}>
                      <Typography component="div" gutterBottom align="left">
                        Distancia pupilar
                      </Typography>
                    </Grid>

                    <Grid item sm={2}>
                      <Typography component="div" gutterBottom align="left">
                        Altura pupilar
                      </Typography>
                    </Grid>

                    <Grid item sm={2}>
                      <Typography component="div" gutterBottom align="left">
                        Altura párpado inferior
                      </Typography>
                    </Grid>

                    <Grid item sm={2}></Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item sm={2}></Grid>

                    <Grid item sm={2}>
                      <Typography
                        component="div"
                        gutterBottom
                        align="center"
                        sx={{ fontWeight: "bold" }}
                      >
                        Ojo derecho
                      </Typography>
                    </Grid>

                    <Grid item sm={2}>
                      <TextField
                        id="distancia_pupilar_od"
                        size="small"
                        sx={{ width: "50%" }}
                        inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                        name="distancia_pupilar_od"
                        value={anteojo.distancia_pupilar_od}
                      />
                    </Grid>

                    <Grid item sm={2}>
                      <TextField
                        id="altura_pupilar_od"
                        size="small"
                        sx={{ width: "50%" }}
                        inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                        name="altura_pupilar_od"
                        value={anteojo.altura_pupilar_od}
                      />
                    </Grid>

                    <Grid item sm={2}>
                      <TextField
                        id="altura_parpado_inferior_od"
                        size="small"
                        sx={{ width: "50%" }}
                        inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                        name="altura_parpado_inferior_od"
                        value={anteojo.altura_parpado_inferior_od}
                      />
                    </Grid>

                    <Grid item sm={2}></Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item sm={2}></Grid>

                    <Grid item sm={2}>
                      <Typography
                        component="div"
                        gutterBottom
                        align="center"
                        sx={{ fontWeight: "bold" }}
                      >
                        Ojo izquierdo
                      </Typography>
                    </Grid>

                    <Grid item sm={2}>
                      <TextField
                        id="distancia_pupilar_oi"
                        size="small"
                        sx={{ width: "50%" }}
                        inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                        name="distancia_pupilar_oi"
                        value={anteojo.distancia_pupilar_oi}
                      />
                    </Grid>

                    <Grid item sm={2}>
                      <TextField
                        id="altura_pupilar_oi"
                        size="small"
                        sx={{ width: "50%" }}
                        inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                        name="altura_pupilar_oi"
                        value={anteojo.altura_pupilar_oi}
                      />
                    </Grid>

                    <Grid item sm={2}>
                      <TextField
                        id="altura_parpado_inferior_oi"
                        size="small"
                        sx={{ width: "50%" }}
                        inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                        name="altura_parpado_inferior_oi"
                        value={anteojo.altura_parpado_inferior_oi}
                      />
                    </Grid>

                    <Grid item sm={2}></Grid>
                  </Grid>
                </Grid>
              </Box>

              {anteojo.anteojoTratamientoRows.length > 0 && (
                <Accordion
                  sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    Tratamientos
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px" }}>
                      <DataGrid
                        rows={anteojo.anteojoTratamientoRows}
                        columns={tableColumnsTratamiento}
                        {...tableOptions}
                      />
                    </Box>
                  </AccordionDetails>
                </Accordion>
              )}
            </>
          )}

          {esArreglo && (
            <>
              {arreglo.pase_de_cristales && (
                <Typography variant="subtitle1" gutterBottom>
                  PASE DE CRISTALES
                </Typography>
              )}
              <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Anteojo y Cristales del Cliente
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <TextField
                      id="descripcion_anteojo_cristales"
                      label="Anteojo y Cristales del Cliente"
                      size="small"
                      sx={{ width: "100%" }}
                      inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                      name="descripcion_anteojo_cristales"
                      value={
                        arreglo.descripcion_anteojo_cristales
                          ? arreglo.descripcion_anteojo_cristales
                          : ""
                      }
                      variant="outlined"
                      multiline
                    />
                  </Grid>
                </Grid>
              </Box>

              {arreglo.pase_de_cristales && arreglo.montura_nuevo_cliente === "nuevo" && (
                <>
                  <Box
                    sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}
                  >
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Armazón / Anteojo de Sol
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="armazonAsol"
                        label="Código - Descripción - Marca - Modelo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="armazonAsol"
                        value={arreglo.armazonAsol}
                      />
                    </Grid>
                  </Box>
                </>
              )}

              {arreglo.pase_de_cristales && arreglo.montura_nuevo_cliente === "cliente" && (
                <>
                  <Box
                    sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}
                  >
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Armazón / Anteojo de Sol
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="estado_montura"
                        label="Estado de la montura"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="estado_montura"
                        value={arreglo.estado_montura}
                      />
                    </Grid>
                  </Box>
                </>
              )}

              {arreglo.arregloServicioRows.length > 0 && (
                <Accordion sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    Servicios
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px" }}>
                      <DataGrid
                        rows={arreglo.arregloServicioRows}
                        columns={tableColumnsServicio}
                        {...tableOptions}
                      />
                    </Box>
                  </AccordionDetails>
                </Accordion>
              )}

              {arreglo.arregloTratamientoRows.length > 0 && (
                <Accordion sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    Tratamientos
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px" }}>
                      <DataGrid
                        rows={arreglo.arregloTratamientoRows}
                        columns={tableColumnsTratamiento}
                        {...tableOptions}
                      />
                    </Box>
                  </AccordionDetails>
                </Accordion>
              )}

              {arreglo.arregloFornituraRows.length > 0 && (
                <Accordion sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    Fornituras
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px" }}>
                      <DataGrid
                        rows={arreglo.arregloFornituraRows}
                        columns={tableColumnsFornitura}
                        {...tableOptions}
                      />
                    </Box>
                  </AccordionDetails>
                </Accordion>
              )}
            </>
          )}
        </Box>
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};
export default DatosAnteojoArreglo;
